import { Component } from '@angular/core';

@Component({
  selector: 'app-reports-resume',
  templateUrl: './reports-resume.component.html',
  styleUrl: './reports-resume.component.scss'
})
export class ReportsResumeComponent {}
